import { ActionType } from '../../../core/redux/actionType';
import { Action } from 'redux';
import { AppState } from '../../../core/redux/appState';
import * as R from 'ramda';


/**
 * Dispatch this action to clear the email the user last sent their dev plan to.
 */
export const clearLastSentEmailAction = () => ({
  type: ActionType.ClearLastSentEmail,
});


export const clearLastSentEmailReducer = (state: AppState, action: Action): AppState => {
  if(action.type !== ActionType.ClearLastSentEmail) {
    return state;
  }

  return R.dissocPath(['devPlan', 'lastEmailRecipient'], state);
};
